var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M617.539,15.425a.8.8,0,0,0,.119-.01l3.365-.59a.2.2,0,0,0,.106-.056l8.478-8.478a.2.2,0,0,0,.044-.065.2.2,0,0,0,0-.153.2.2,0,0,0-.044-.065l-3.324-3.326a.2.2,0,0,0-.143-.058.2.2,0,0,0-.142.058l-8.478,8.478a.209.209,0,0,0-.056.106l-.59,3.364a.666.666,0,0,0,.188.6A.678.678,0,0,0,617.539,15.425Zm1.348-3.488,7.253-7.252,1.466,1.466L620.353,13.4l-1.778.314Zm11.1,5.168h-14.72a.639.639,0,0,0-.64.64v.72a.16.16,0,0,0,.159.16h15.681a.16.16,0,0,0,.16-.16v-.72A.639.639,0,0,0,629.985,17.105Z",
    transform: "translate(-614.625 -2.625)",
    fill: "#4d6382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit-black.6c49ad6ed1f342cfcad49891078dd453.svg";
export { ForwardRef as ReactComponent };